import { faPlus } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, useOnClickOutside } from "@joonapp/web-shared"
import { useRef, useState } from "react"

import useActionButtonPosition from "../../hooks/useActionButtonPosition"

interface AnimatedButtonGroupProps {
  children: React.ReactNode | React.ReactNode[]
}

export const AnimatedButtonGroup = ({ children }: AnimatedButtonGroupProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const buttonBottomPos = useActionButtonPosition()
  const ref = useRef<HTMLDivElement>(null)

  useOnClickOutside(ref, () => setIsOpen(false))

  return (
    <div
      ref={ref}
      className="sticky self-end z-[100] mr-4"
      style={{ bottom: buttonBottomPos }}
    >
      {/* Button Menu */}
      <div className="relative">
        <div
          className={`absolute bottom-full right-0 flex flex-col items-end gap-2 mb-2 transition-all duration-300 ease-in-out ${
            isOpen
              ? "opacity-100 translate-y-0 pointer-events-auto"
              : "opacity-0 translate-y-5 pointer-events-none"
          }`}
        >
          {children}
        </div>

        {/* Main Toggle Button */}
        <Button
          onClick={() => setIsOpen(!isOpen)}
          className="p-3 h-14 max-h-14 min-h-14 min-w-14 max-w-14 z-10"
          text={
            <FontAwesomeIcon
              icon={faPlus}
              className={`transition-transform duration-300 ${isOpen ? "rotate-45" : "rotate-180"}`}
              fontSize={20}
            />
          }
        />
      </div>
    </div>
  )
}

export default AnimatedButtonGroup
